import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhotoDirective } from './photo.directive';
import { WhatisthisTooltipDirective } from './whatisthis-tooltip.directive';



@NgModule({
  declarations: [PhotoDirective, WhatisthisTooltipDirective],
  exports: [
    PhotoDirective,
    WhatisthisTooltipDirective,
  ],
  imports: [
    CommonModule
  ]
})
export class DirectiveModule { }
